import cx from "classnames";
import React from "react";
import { Field } from "redux-form";

import { ToolbarTheme } from "@/mk2/containers/Toolbar/Toolbar";

import styles from "./ToolbarAdditionalCheckbox.mscss";

interface OwnProps {
    isAdminUI?: boolean;
    label: string;
    name: string;
    theme?: ToolbarTheme;
}

type Props = OwnProps;

export class ToolbarAdditionalCheckbox extends React.Component<Props> {
    public render() {
        const { isAdminUI, label, name, theme } = this.props;

        return (
            <label
                className={cx(
                    styles.ToolbarAdditionalCheckbox,
                    theme === ToolbarTheme.Blue && styles["ToolbarAdditionalCheckbox--blue"],
                    theme === ToolbarTheme.Black && styles["ToolbarAdditionalCheckbox--black"],
                    isAdminUI && styles["ToolbarAdditionalCheckbox--isAdminUI"],
                )}
            >
                <Field name={name} component="input" type="checkbox" />
                {label}
            </label>
        );
    }
}
